var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('card', [_c('div', {
    staticClass: "\n    d-flex\n    flex-wrap flex-nowrap\n    justify-content-between\n    padding-top-2x padding-bottom-1x\n  "
  }, _vm._l(_vm.items, function (item, index) {
    return _c('step', {
      key: index,
      attrs: {
        "isActive": item.path === _vm.current.path,
        "isCompleted": _vm.isPrevious(item),
        "number": index + 1,
        "title": _vm.$t(item.title)
      }
    });
  }), 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }